export type DataEnvironment = {
  id: number;
  name: string;
  subdomain: string;
  links: Array<AppModule>;
  url: string;
};

export interface AppModule {
  abbreviation: string;
  moduleName: string;
  name: string;
  url: string;
}

export const SOLOVIS_ACADAMY_MODULE = 'SolovisAcademy';
